import type { Ref } from 'vue';
import api from '@sub/api/api';

export function useOrderedTimeSlots(serviceId: Ref<number>) {
  const controller = new AbortController();
  const signal = controller.signal;

  function fetchOrderedTimeSlots() {
    if (!serviceId.value) return;
    return api.slots.all({
      serviceIds: [serviceId.value],
      dateTimeStart: getSlotsStartDate().toISOString(),
      limit: 500,
      returnService: false,
      returnOrder: false
    }, signal);
  }

  const key = computed(() => String(serviceId.value));
  const { status, data: orderedTimeSlots } = useAsyncData(key, fetchOrderedTimeSlots, {
    default: () => [],
  });

  return {
    pendingSlots: computed(() => status.value === 'pending'),
    orderedTimeSlots,
  };
}
